<div [copoScroller] class="sidenav-content" @routeAnimation>

	<!-- Title -->
	<div class="card-title-block-non-sticky">
		<div class="card-title-label" translate>footer.search</div>
	</div>

	<ng-container *ngIf="searchStarted">

		<!-- Filters -->
		<div class="copo-filter-block">
			<div class="copo-label" translate>search.display</div>
			<div>
				<button *ngIf="!accessToOnlyOneSearchResult"
					type="button" mat-flat-button
					[color]="selectedResultName === undefined ? 'primary' : undefined"
					[class.copo-button-selection-selected]="selectedResultName === undefined"
					class="copo-button-selection copo-button-selection-margin"
					(click)="filterResults()"
				>
					<span translate>filter.all</span>
				</button>
				<ng-container *ngFor="let serviceOp of searchOperators">
					<button
						*ngIf="hasAccess(serviceOp)"
						type="button" mat-flat-button
						[color]="selectedResultName === serviceOp.name ? 'primary' : undefined"
						[class.copo-button-selection-selected]="selectedResultName === serviceOp.name"
						class="copo-button-selection copo-button-selection-margin"
						(click)="filterResults(serviceOp.name)"
					>
						<span translate>{{serviceOp.resultGroupTitle}}</span>
					</button>
				</ng-container>
			</div>
		</div>

		<!-- Service results: one section per operator, progressively loaded -->
		<ng-container *ngFor="let serviceOp of searchOperators">
			<ng-container *ngIf="hasAccess(serviceOp) && (selectedResultName === undefined || selectedResultName === serviceOp.name)">
				<ng-container *ngIf="getSectionState(serviceOp.name) as section">
					<div class="card-title-block-non-sticky">
						<span class="card-title-label" translate>{{serviceOp.resultGroupTitle}}</span>
						<ng-container *ngIf="section.result as serviceResult">
							<button type="button" mat-button class="copo-result-count"
								[disabled]="serviceResult.result.count === 0"
								(click)="navigateToServiceResults(serviceOp.name)">{{
									serviceResult.result.count === 0
									? ('order-tracking.no.result' | translate)
									: serviceResult.result.count > 1
									? ('search.see.results' | translate:{ value: serviceResult.result.count | copoNumber:'number' })
									: ('search.see.result' | translate)
								}}
							</button>
						</ng-container>
					</div>
					<copo-loading-spinner *ngIf="section.loading"></copo-loading-spinner>
					<ng-container *ngIf="section.result as serviceResult">
						<div class="copo-container copo-result-cards-container">
							<ng-container *ngIf="serviceResult.name === 'offerDraft'">
								<copo-result-offer-card *ngFor="let entry of serviceResult.result.results" [offerLine]="entry"></copo-result-offer-card>
							</ng-container>
							<ng-container *ngIf="serviceResult.name === 'offer'">
								<copo-result-offer-card *ngFor="let entry of serviceResult.result.results" [offerLine]="entry"></copo-result-offer-card>
							</ng-container>
							<ng-container *ngIf="serviceResult.name === 'fastlane'">
								<copo-result-fastlane-card *ngFor="let entry of serviceResult.result.results" [fastlane]="entry"></copo-result-fastlane-card>
							</ng-container>
							<ng-container *ngIf="serviceResult.name === 'order'">
								<copo-result-order-card *ngFor="let entry of serviceResult.result.results" [order]="entry"></copo-result-order-card>
							</ng-container>
							<ng-container *ngIf="serviceResult.name === 'sbOrder'">
								<copo-result-sb-order-card *ngFor="let entry of serviceResult.result.results" [sbOrder]="entry"></copo-result-sb-order-card>
							</ng-container>
							<ng-container *ngIf="serviceResult.name === 'claim'">
								<copo-result-claim-card *ngFor="let entry of serviceResult.result.results" [claim]="entry"></copo-result-claim-card>
							</ng-container>
							<ng-container *ngIf="serviceResult.name === 'guarantee'">
								<copo-result-guarantee-card *ngFor="let entry of serviceResult.result.results" [guarantee]="entry"></copo-result-guarantee-card>
							</ng-container>
							<ng-container *ngIf="serviceResult.name === 'batch'">
								<copo-result-batch-card *ngFor="let entry of serviceResult.result.results" [batch]="entry"></copo-result-batch-card>
							</ng-container>
							<ng-container *ngIf="serviceResult.name === 'shipment'">
								<copo-result-shipment-card *ngFor="let entry of serviceResult.result.results" [shipment]="entry"></copo-result-shipment-card>
							</ng-container>
							<ng-container *ngIf="serviceResult.name === 'dispatch-advice'">
								<copo-result-dispatch-advice-card *ngFor="let entry of serviceResult.result.results" [document]="entry" [getUniqueOrderName]="getUniqueOrderName"></copo-result-dispatch-advice-card>
							</ng-container>
							<ng-container *ngIf="serviceResult.name === 'invoice'">
								<copo-result-invoice-card *ngFor="let entry of serviceResult.result.results" [document]="entry" [getUniqueOrderName]="getUniqueOrderName"></copo-result-invoice-card>
							</ng-container>
							<ng-container *ngIf="serviceResult.name === 'certificate'">
								<copo-result-certificate-card *ngFor="let entry of serviceResult.result.results" [document]="entry"></copo-result-certificate-card>
							</ng-container>
							<ng-container *ngIf="serviceResult.name === 'order-acknowledgment'">
								<copo-result-order-acknowledgment-card *ngFor="let entry of serviceResult.result.results" [document]="entry"></copo-result-order-acknowledgment-card>
							</ng-container>
						</div>
					</ng-container>
				</ng-container>
			</ng-container>
		</ng-container>

	</ng-container>
</div>
